import React, { useState, useRef } from "react";
import { QrReader } from "@blackbox-vision/react-qr-reader";
import "./ListMontagem.css";
import blogFetch from "../../axios/config";

export default function QRCodeReaderListaMontagem({ setCode }) {
  const [cameraAtiva, setCameraAtiva] = useState(false);
  const lendoRef = useRef(false); // evita múltiplos POSTs

  const handleError = (err) => {
    console.error("Erro na leitura do QR Code:", err);
  };

  const enviarLeituraParaApi = async (ordem) => {



    try {
      await blogFetch.post("IAcompanhamentoMontagem/acompanhamento", {Ordem: ordem})
    } catch (error) { 
      console.error("Erro ao enviar leitura para API:", error);
    }
  };

  const handleScan = async (result, error) => {
    if (error) {
      console.debug("QR reader error:", error);
      return;
    }

    if (!result || lendoRef.current) return;

    let texto = null;

    if (typeof result === "string") {
      texto = result;
    } else if (result?.text) {
      texto = result.text;
    } else if (typeof result?.getText === "function") {
      try {
        texto = result.getText();
      } catch (e) {
        console.debug("getText falhou", e);
      }
    }

    if (!texto) return;

    lendoRef.current = true;

    setCode(texto);
    await enviarLeituraParaApi(texto);

    setTimeout(() => {
      setCameraAtiva(false);
      lendoRef.current = false;
    }, 300);
  };

  return (
    <div className="qrWrapper_listaMontagem">
      <button
        className="btnAbrirCamera"
        onClick={() => setCameraAtiva((prev) => !prev)}
      >
        <span role="img" aria-label="camera" style={{ fontSize: "1.2em" }}>
          📷
        </span>
        {cameraAtiva ? "Fechar Leitor" : "Ler QR Code"}
      </button>

      {cameraAtiva && (
        <div className="qrCameraBox">
          <QrReader
            onError={handleError}
            onResult={handleScan}
            constraints={{
              facingMode: { ideal: "environment" },
              width: { ideal: 640 },
              height: { ideal: 480 },
            }}
            videoStyle={{ width: "100%", height: "100%", objectFit: "cover" }}
            style={{ width: "100%", height: "100%" }}
            delay={150}
          />
          <div className="qrOverlayCenter" aria-hidden="true"></div>
        </div>
      )}
    </div>
  );
}
